import React from 'react';
import { SlideContainer } from '../SlideContainer';
import { FadeInStagger, FadeIn } from '../FadeIn';
export const Slide08NextSteps = () => {
  const steps = [{
    time: 'Step 1',
    desc: 'Quick demo call to explore fit with your programs and courses'
  }, {
    time: 'Step 2',
    desc: 'Share syllabus, case materials, and learning objectives'
  }, {
    time: 'Step 3',
    desc: 'Master Ed designs and builds modules tailored to your course'
  }, {
    time: 'Step 4',
    desc: 'Pilot with a cohort, iterate based on faculty and student feedback'
  }];
  return <SlideContainer centered data-id="element-213">
      <FadeInStagger className="w-full max-w-4xl flex flex-col items-center" data-id="element-214">
        <FadeIn data-id="element-215">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-white mb-20 text-center" data-id="element-216">
            Getting started is simple
          </h2>
        </FadeIn>

        <div className="w-full grid grid-cols-1 md:grid-cols-4 gap-4 mb-24" data-id="element-217">
          {steps.map((step, i) => <FadeIn key={i} className="relative" data-id="element-218">
              <div className="bg-card border border-white/5 p-6 rounded-2xl h-full flex flex-col items-center text-center" data-id="element-219">
                <div className="text-accent-purple font-mono text-sm mb-4" data-id="element-220">
                  {step.time}
                </div>
                <p className="text-white/70 text-sm leading-relaxed" data-id="element-221">
                  {step.desc}
                </p>
              </div>
              {i < steps.length - 1 && <div className="hidden md:block absolute top-1/2 -right-2 w-4 h-px bg-white/20" data-id="element-222"></div>}
            </FadeIn>)}
        </div>

        <FadeIn data-id="element-223">
          <div className="text-center space-y-4" data-id="element-224">
            <p className="text-xl md:text-2xl text-white/80 font-medium max-w-2xl leading-relaxed" data-id="element-225">
              We'd love to show you what this looks like in action.
            </p>
            <p className="text-base text-white/40" data-id="element-226">
              mahtab.soin@master-ed.com
            </p>
          </div>
        </FadeIn>
      </FadeInStagger>
    </SlideContainer>;
};